export class LmsIdTool {
  attach() {
    const url = window.location.href.endsWith('/')
      ? window.location.href.slice(0, -1)
      : window.location.href
    const coursenum = url.split('/').pop()

    $('#id_filter_name').on('input', function () {
      var content = $(this).val()

      $('tr.user-row').each(function () {
        let $row = $(this)
        let $name = $row.data('filter').toLowerCase()
        if ($name.includes(content.toLowerCase()) || content.length === 0) {
          $row.show()
        } else {
          $row.hide()
        }
      })
    })

    $('.create-btn').on('click.create', function () {
      let lmsId = $(this).data('lmsid')

      $.meDialog.open2({
        url: '/instructor/lms_id_tool.create/' + coursenum + '/' + lmsId + '/',
        id: 'dialog_lms_id_create',
        title: 'Create Student LMS ID',
        width: '450px',
      })
    })
  }
}
